<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Add Company</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <!-- <div class="d-flex gap-3"> -->
      <div class="d-grid gap-3">
        <div class="form-floating">
          <input type="text" required class="form-control" [(ngModel)]="company.CompanyCode" name="companyCode" placeholder="Company Code" />
          <label for="companyCode" class="form-label">Company Code</label>
        </div>
        <div class="form-floating">
          <select class="form-select" name="group" [(ngModel)]="company.Group">
            @for (group of companyGroupList; track group.id) {
              <option [value]="group.id">{{ group.name }}</option>
            }
          </select>
          <label for="group" class="form-label">Company Group</label>
        </div>
        <app-select-business-license [(businessId)]="businessId" [(branchId)]="branchId" [displayBranchOnly]="false"></app-select-business-license>
        <!-- <mat-form-field subscriptSizing="dynamic">
          <mat-label>Business</mat-label>
          <input type="text" matInput [matAutocomplete]="auto" [(ngModel)]="businessId" name="businessId" (input)="filterOptions($event.target.value)" required />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompanyCode" [requireSelection]="true" (optionSelected)="onOptionSelected($event)">
            @for (b of filteredBusinessList; track b.Id) {
              <mat-option [value]="b.Id">{{ b.Name }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (businessId !== undefined) {
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Contact No.</th>
                <th>Email</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              @for (l of businessLicenseList[businessId]; track l.Id) {
                <tr>
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" name="license" (change)="selectLicense($event, l.Id)" [checked]="this.licenseId === l.Id" [disabled]="licenseId && licenseId !== l.Id" />
                    </div>
                  </td>
                  <td>{{ l.ContactNo }}</td>
                  <td>{{ l.Email }}</td>
                  <td>{{ l.FullAddress }}</td>
                </tr>
              }
            </tbody>
          </table>
        } -->
        <div class="form-floating">
          <input type="number" required class="form-control" [(ngModel)]="initialCashBookBalance" name="initialCashBookBalance" (keypress)="sharedService.isNumberKeyAllowNegative($event)" placeholder="Initial Cash Book Balance (RM)" />
          <label for="initialCashBookBalance" class="form-label">Initial Cash Book Balance (RM)</label>
        </div>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Initial Cash Book Date (Next day of latest account)</mat-label>
          <input matInput [matDatepicker]="initialCashBookDatePicker" name="initialCashBookDate" [(ngModel)]="initialCashBookDate" required />
          <mat-datepicker-toggle matSuffix [for]="initialCashBookDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #initialCashBookDatePicker name="initialCashBookDatePicker"></mat-datepicker>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Date Operating</mat-label>
          <input matInput [matDatepicker]="dateOperating" name="dateOperating" [(ngModel)]="company.DateOperating" required />
          <mat-datepicker-toggle matSuffix [for]="dateOperating"></mat-datepicker-toggle>
          <mat-datepicker #dateOperating name="date"></mat-datepicker>
        </mat-form-field>
      </div>
      <!-- <div class="vr"></div>
                <div class="flex-fill">
                    <div class="d-grid gap-3">

                    </div>
                </div> -->
      <!-- </div> -->
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-success" type="button" (click)="submit()">Add Company</button>
    <button class="btn btn-outline-danger" type="button" data-dismiss="modal" (click)="reset()">Cancel</button>
  </div>
</form>
